module.exports = __webpack_public_path__ + "img/Mathematics.717bb01c.svg";